import { AccordionDetailsList } from '../AccordionDetailsList';
import { PortfolioAccordionDetails } from '../PortfolioAccordionDetails';

import { RentalIncomeDetailsList, RentalIncomeDetailsListProps } from '../../../common/detailsList';

export const RentalIncomeAccordionDetails = (props: RentalIncomeDetailsListProps) => (
  <PortfolioAccordionDetails>
    <AccordionDetailsList>
      <RentalIncomeDetailsList {...props} />
    </AccordionDetailsList>
  </PortfolioAccordionDetails>
);
